import { usePrimaryPage } from '@/PageManager'

export function EmbeddedHashtag({ hashtag }: { hashtag: string }) {
  const { navigate } = usePrimaryPage()
  const tag = hashtag.replace('#', '')

  return (
    <span
      className="text-primary hover:underline cursor-pointer"
      onClick={(e) => {
        e.stopPropagation()
        navigate('search', { input: `#t:${tag}` })
      }}
    >
      {hashtag[0] === '#' ? '' : '#'}
      {hashtag}
    </span>
  )
}
